"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  FileUpload: {
    border: '1px dashed #707070',
    transition: 'all 150ms ease-in-out'
  },
  InputWrapper: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  Input: {
    display: 'none'
  },
  ChooseLabel: {
    color: '#368ef8'
  },
  Label: {
    cursor: 'pointer',
    minHeight: 190,
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  Icon: {
    fontSize: 40,
    pointerEvents: 'none'
  },
  Dragging: {
    background: '#eaf3ff',
    border: '1px dashed #4c8ff0'
  },
  Text: {
    pointerEvents: 'none'
  }
};
exports["default"] = _default;
//# sourceMappingURL=style.js.map